/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8.5 6L6 8.50007M6 8.50007L8.5 11.0001M6 8.50007H14M15.5 13L18 15.5M18 15.5L15.5 18M18 15.5H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M8.5 6L6 8.50007M6 8.50007L8.5 11.0001M6 8.50007H14M15.5 13L18 15.5M18 15.5L15.5 18M18 15.5H10M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.03034 6.53025C9.32323 6.23736 9.32322 5.76248 9.03032 5.46959C8.73743 5.1767 8.26255 5.17671 7.96966 5.46961L5.46966 7.96968C5.17678 8.26257 5.17678 8.73744 5.46967 9.03033L7.96967 11.5303C8.26256 11.8232 8.73744 11.8232 9.03033 11.5303C9.32322 11.2374 9.32322 10.7626 9.03033 10.4697L7.81066 9.25H14C14.4142 9.25 14.75 8.91421 14.75 8.5C14.75 8.08579 14.4142 7.75 14 7.75H7.81062L9.03034 6.53025ZM16.0303 12.4697C15.7374 12.1768 15.2626 12.1768 14.9697 12.4697C14.6768 12.7626 14.6768 13.2374 14.9697 13.5303L16.1893 14.75H10C9.58579 14.75 9.25 15.0858 9.25 15.5C9.25 15.9142 9.58579 16.25 10 16.25H16.1893L14.9697 17.4697C14.6768 17.7626 14.6768 18.2374 14.9697 18.5303C15.2626 18.8232 15.7374 18.8232 16.0303 18.5303L18.5303 16.0303C18.8232 15.7374 18.8232 15.2626 18.5303 14.9697L16.0303 12.4697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M8.5 6L6 8.50007M6 8.50007L8.5 11.0001M6 8.50007H14M15.5 13L18 15.5M18 15.5L15.5 18M18 15.5H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8.5 6L6 8.50007M6 8.50007L8.5 11.0001M6 8.50007H14M15.5 13L18 15.5M18 15.5L15.5 18M18 15.5H10M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.03032 5.46966C9.32322 5.76255 9.32323 6.23743 9.03034 6.53032L7.81062 7.75007H14C14.4142 7.75007 14.75 8.08586 14.75 8.50007C14.75 8.91428 14.4142 9.25007 14 9.25007H7.81066L9.03033 10.4697C9.32322 10.7626 9.32322 11.2375 9.03033 11.5304C8.73744 11.8233 8.26256 11.8233 7.96967 11.5304L5.46967 9.0304C5.17678 8.73751 5.17678 8.26264 5.46966 7.96975L7.96966 5.46968C8.26255 5.17678 8.73743 5.17677 9.03032 5.46966ZM14.9697 12.4697C15.2626 12.1768 15.7374 12.1768 16.0303 12.4697L18.5303 14.9697C18.8232 15.2626 18.8232 15.7375 18.5303 16.0304L16.0303 18.5304C15.7374 18.8233 15.2626 18.8233 14.9697 18.5304C14.6768 18.2375 14.6768 17.7626 14.9697 17.4697L16.1893 16.2501H10C9.58579 16.2501 9.25 15.9143 9.25 15.5001C9.25 15.0859 9.58579 14.7501 10 14.7501H16.1893L14.9697 13.5304C14.6768 13.2375 14.6768 12.7626 14.9697 12.4697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
